import api from "./ApiURLBase";
const EndPointGetVehicle = async (miningSite) => await api.get(`/vehicles?miningSite=${miningSite}`);
const EndPointGetDashWorkVehicle = async (miningSite) =>
  await api.get(`/dashboard/work/vehicles?miningSite=${miningSite}`);
const EndPointGetDashWorkVehiclesId = async (id, miningSite) => {
  return api.get(`/dashboard/work/vehicles/${id}?miningSite=${miningSite}`);
};
const EndPointGetDashWorkProgramated = async (miningSite) => {
  return api.get(`/dashboard/work/vehiclesNotProgramated?miningSite=${miningSite}`);
};
const EndPointGetDashWork = async (miningSite) => await api.get(`/dashboard/work?miningSite=${miningSite}`);
const EndPointGetDashWorkGlobal = async () => await api.get(`/dashboard/work/detail`);

const EndpointDashWorkCollect = async (idV, position, value, miningSite) => {
  return api.get(
    `/dashboard/work/vehicles/${idV}/collect-points/${position}?isProgramated=${value}&miningSite=${miningSite}`
  );
};
export {
  EndPointGetVehicle,
  EndPointGetDashWork,
  EndPointGetDashWorkGlobal,
  EndPointGetDashWorkVehicle,
  EndPointGetDashWorkProgramated,
  EndPointGetDashWorkVehiclesId,
  EndpointDashWorkCollect,
};
